module.exports = __webpack_public_path__ + "img/img42.856fbf9d.svg";